import { T_ADULT_WELCOME_POPUP_PAGE_CONSTANTS } from './TYPES'

const HU_ADULT_WELCOME_POPUP_PAGE_CONSTANTS: T_ADULT_WELCOME_POPUP_PAGE_CONSTANTS =
  {
    TITLE: 'Üdvözöljük a GriffyReads kvízkönyvtárban!',
    KICKER: 'Mielőtt gyermeke elkezdhetne olvasni...',
    BODY: 'A GriffyReads gyerekeknek készült. A kvízek, olvasáskihívások és események eléréséhez gyermekének saját fiókra van szüksége, amelyet kevesebb mint egy perc alatt létrehozhat.',
    STEP_1_TITLE: '1. Gyermekfiók létrehozása',
    STEP_1_BODY: 'Hozza létre gyermeke profilját néhány egyszerű lépésben.',
    STEP_2_TITLE: '2. A gyermek bejelentkezik',
    STEP_2_BODY:
      'A gyermek a saját fiókjával lép be a GriffyReads-be és tölt ki kvízeket.',
    STEP_3_TITLE: '3. Olvass, játssz és fejlődj!',
    STEP_3_BODY:
      'A gyerekek kvízeket tölthetnek ki, pontokat gyűjthetnek és csatlakozhatnak az olvasáskihívásokhoz és eseményekhez.',
    PRIMARY_CTA: 'Gyermekfiók létrehozása',
    SECONDARY_CTA: 'Talán később',
    FOOTER:
      'A felnőtt fiókok ingyenesek. Gyermekek önállóan nem hozhatnak létre fiókot.'
  }

export default HU_ADULT_WELCOME_POPUP_PAGE_CONSTANTS
